import { useGetAppDetailsQuery, useUpdateAppProjectMutation } from '@app/services';
import { NamespaceStatus } from '@common';
import { ModalProps } from 'antd';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function useUpdateNameStatus({ modalOpen, setModalOpen }: IProps) {
    const { name } = useParams();
    const [appStatus, setAppStatus] = useState<NamespaceStatus>(NamespaceStatus.archived);
    const [updateAppProject] = useUpdateAppProjectMutation();

    const { data: app } = useGetAppDetailsQuery(name as string, { skip: !name });

    const handleCancel = () => {
        setModalOpen(false);
    };

    const handleOk = useCallback(async () => {
        try {
            const payload = { namespaceStatus: appStatus };
            await updateAppProject({ body: payload as any, id: app?._id as string }).unwrap();
        } catch (error: any) {
            console.log(error);
        }
        setModalOpen(false);
    }, [app, updateAppProject, appStatus, setModalOpen]);

    const OkBtnTextMap: { [key in NamespaceStatus]?: string } = {
        active: 'Active',
        reserved: 'Reserve',
        archived: 'Archive',
        removed: 'Delete',
    };

    const modalProps: ModalProps = {
        open: modalOpen,
        onCancel: handleCancel,
        onOk: handleOk,
        title: `Delete ${name} App ?`,
        width: 600,
        okText: OkBtnTextMap[appStatus],
        cancelText: 'Cancel',
        centered: true,
        okButtonProps: { danger: appStatus === NamespaceStatus.removed },
    };
    return {
        modalProps,
        appStatus,
        setAppStatus,
    };
}

interface IProps {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
}
